import React, { useState, ChangeEvent } from 'react';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import StyledButton from 'components/UI/Button/StyledButton';
import { FontSize, FontWeight } from 'modules/styles/variables';
import {
  MuiRow,
  DialogPopUp,
  StyledAutoComplete,
  SearchBarSection,
  SearchPopUpHeader,
  HeaderRow,
  OkayDiv
} from '../styled';
import { Svg } from 'components/UI/Svg';
import { Color } from 'modules/styles/colors';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import Config from 'react-native-config';
import { KeyValue } from 'store/preRegistration/types';

type option = {
  key: string;
  value: string;
};

interface ReligionSelectionListProps {
  religionList: option[];
  handleReligionAccept: (selectedReligion: KeyValue) => void;
}

export const ReligionSelectionList = ({
  religionList,
  handleReligionAccept
}: ReligionSelectionListProps) => {
  const [open, setOpen] = React.useState(false);
  const [selectedReligion, setSelectedReligion] = useState<KeyValue>();
  const ALLOW_UPDATE = Config.PRE_REG_ALLOW_SAVE_PATIENT_DATA === 'enabled';
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleChangeSearchBar = (e: ChangeEvent<HTMLInputElement>) => {
    if (!e) return;

    setSelectedReligion(e.currentTarget.value);
  };

  const selected = (option: option, against: option) => {
    setSelectedReligion(against);
    return option.key === against.key;
  };

  const onReligionAccept = () => {
    if (selectedReligion) {
      handleReligionAccept(selectedReligion);
    }
    setOpen(false);
  };

  const unorderedReligionOptions = [...religionList];
  const orderedReligionOptions = unorderedReligionOptions.sort((a, b) => (a.key < b.key ? -1 : 1));
  return (
    <>
      <MuiRow>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogPopUp>
            <HeaderRow>
              <MuiRow>
                <ArrowBackIcon onClick={handleClose} />
                <SearchPopUpHeader fontSize={FontSize.xlarge} fontWeight={FontWeight.bold}>
                  Select Religion
                </SearchPopUpHeader>
              </MuiRow>
            </HeaderRow>
            <SearchBarSection>
              <StyledAutoComplete
                id="combo-box-demo"
                options={orderedReligionOptions}
                getOptionLabel={(option: option) => option.key}
                getOptionSelected={selected}
                onInputChange={handleChangeSearchBar}
                open
                renderInput={params => (
                  <>
                    <Svg className="search-icon" set="material" name="search" color={Color.black} />
                    <TextField {...params} className="searchField" variant="outlined" />
                  </>
                )}
              />
            </SearchBarSection>
          </DialogPopUp>
          <OkayDiv>
            <StyledButton onClick={onReligionAccept}>OK</StyledButton>
          </OkayDiv>
        </Dialog>
      </MuiRow>
      {ALLOW_UPDATE ? (
        <Button color="primary" onClick={handleClickOpen}>
          Edit
        </Button>
      ) : null}
    </>
  );
};

export default ReligionSelectionList;
